import request from '../utils/request';
import qs from "qs";

export function getCompanyList(param) {
    return request({
        url: '/admin/search-company',
        method: 'GET',
        params: param
    })
}

export function getCompanyOptions() {
    return request({
        url: '/admin/company-type',
        method: 'GET'
    })
}

export function saveCompany(data,id) {
    if(id){
        return request({
            url: '/admin/company/' + id,
            method: 'PUT',
            data
        })
    }else {
        return request({
            url: '/admin/company',
            method: 'POST',
            data
        })
    }
}

export function getCompanyDeatil(id){
    return request({
        url: '/admin/company/'+id,
        method: 'GET'
    })
}

export function setCompanyIsValidate(id,isValidate) {
    return request({
        url: '/admin/company/'+id+'/is-validate/'+isValidate,
        method: 'PUT',
    })
}

export function getCompanyStaff(param) {
    return request({
        url: '/admin/company/search-admin',
        method: 'GET',
        params:param
    })
}

export function getAgentFranchisee(id) {
    return request({
        url: '/admin/company/'+id+'/agent-company',
        method: 'get'
    })
}

export function setAgentFranchisee(id,data) {
    return request({
        url: '/admin/company/agent/'+id,
        method: 'PUT',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({"ids":data.ids})
    })
}

export function setCompanyType(id,type) {
    return request({
        url: '/admin/company/'+id+'/type/'+type,
        method: 'PUT'
    })
}

// 获取企业角色

export function getCompanyRole(id) {
    return request({
        url: '/admin/search-company-role/'+id,
        method: 'GET',
    })
}

//添加企业员工
export function addCompanyStaff(id,data) {
        return request({
            url: '/admin/company-admin/'+id,
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            data: JSON.stringify(data)
        })
}

export function setAccountInfo(data) {
    return request({
        url: '/admin/company/updateSharingInfo',
        method: 'PUT',
        data
    })
}

export function getAccount(id) {
    return request({
        url: '/admin/company/getSharingInfo?id='+id,
        method: 'GET',
    })
}